import { gql } from '@apollo/client';

const getQueryArgs = (objectType: string, options: any) => {
  const args: string[] = ['$endDate: Date!', '$mwrr: Boolean!', '$twrr: Boolean!'];

  switch (objectType) {
    case 'INDIVIDUAL':
    case 'NON_INDIVIDUAL':
      args.push('$includeGoals: Boolean!');
      args.push('$includeAccounts: Boolean!');
      args.push('$includeSubAccounts: Boolean!');
      args.push('$includeSelfMwrr: Boolean!');
      args.push('$includeSelfTwrr: Boolean!');
      break;
    case 'ACCOUNT':
      args.push('$includeSubAccounts: Boolean!');
      args.push('$includeSelfMwrr: Boolean!');
      args.push('$includeSelfTwrr: Boolean!');
      break;
    case 'GOAL':
      args.push('$includeSubAccounts: Boolean!');
      args.push('$includeSelfMwrr: Boolean!');
      args.push('$includeSelfTwrr: Boolean!');
      break;
    case 'HOUSEHOLD':
      args.push('$includeGoals: Boolean!');
      args.push('$includeAccounts: Boolean!');
      args.push('$includeSubAccounts: Boolean!');
      args.push('$includeUser: Boolean!');
      args.push('$includeSelfMwrr: Boolean!');
      args.push('$includeSelfTwrr: Boolean!');
      break;
    default:
      break;
  }

  const timeFrames = ['oneMonth', 'threeMonth', 'sixMonth', 'oneYear', 'threeYear', 'fiveYear', 'sinceInception', 'yearToDate'];

  timeFrames.forEach((key) => {
    if (key === 'yearToDate') {
      args.push('$ytdStart: Date!');
    } else if (options[key]) {
      args.push(`$${key}Start: Date`);
    }
  });

  return args.join(',\n');
};

const SUBACCOUNT_STATS_FETCH = (statistics: string, objectType: string, options: any) => gql`
  query fetchSubAccount(
      $id: ObjectID!,
      ${getQueryArgs(objectType, options)}
    ) {
    fetchSubAccount(subAccountId: $id) {
      subAccount {
        id
        name
        goal { type }
        account { type }
        ${statistics}
      }
    }
  }
  `;

const ACCOUNT_STATS_FETCH = (statistics: string, mainObjectStatistics: string, options: any, objectType: string) => gql`
  query fetchAccount(
      $id: ObjectID!,
      ${getQueryArgs(objectType, options)}
    ) {
    fetchAccount(accountId: $id) {
      account {
        id
        ${mainObjectStatistics}
        subAccounts @include(if: $includeSubAccounts) {
          id
          name
          ${statistics}
          goal { type }
          account { type }
        }
      }
    }
  }
  `;

const GOAL_STATS_FETCH = (statistics: string, mainObjectStatistics: string, options: any, objectType: string) => gql`
query fetchGoal(
    $id: ObjectID!,
    ${getQueryArgs(objectType, options)}
  ) {
  fetchGoal(goalId: $id) {
    goal {
      id
      ${mainObjectStatistics}
      subAccounts @include(if: $includeSubAccounts) {
        id
        name
        ${statistics}
        goal { type }
        account { type }
        }
    }
  }
}
`;

const USER_STATS_FETCH = (statistics: string, mainObjectStatistics: string, options: any, objectType: string) => gql`
query fetchUser(
    $id: ObjectID!,
    ${getQueryArgs(objectType, options)}
  ) {
  fetchUser(userId: $id) {
    user {
      id
      ${mainObjectStatistics}
      goals @include(if: $includeGoals) {
        id
        type
        ${statistics}
      }
      accounts @include(if: $includeAccounts) {
        id
        type
        ${statistics}
      }
      subAccounts @include(if: $includeSubAccounts) {
        id
        name
        ${statistics}
        goal { type }
        account { type }
      }
    }
  }
}
`;

const CLIENTGROUP_STATS_FETCH = (statistics: string, mainObjectStatistics: string, options: any, objectType: string) => gql`
query fetchClientGroup(
    $id: ObjectID!,
    ${getQueryArgs(objectType, options)}
  ) {
  fetchClientGroup(clientGroupId: $id) {
    clientGroup {
      id
      name
      ${mainObjectStatistics}
      primaryUser @include(if: $includeUser) {
        id
        firstName
        lastName
        ${statistics}
      }
      goals @include(if: $includeGoals) {
        id
        type
        ${statistics}
      }
      accounts @include(if: $includeAccounts) {
        id
        type
        ${statistics}
      }
      subAccounts @include(if: $includeSubAccounts) {
        id
        name
        ${statistics}
        goal { type }
        account { type }
      }
    }
  }
}
`;

export const chooseStatsQuery = ({
  objectType, statistics, mainObjectStatistics, options,
}: { objectType: string; statistics: string; mainObjectStatistics: string; options: any }) => {
  switch (objectType) {
    case 'INDIVIDUAL':
    case 'NON_INDIVIDUAL':
      return USER_STATS_FETCH(statistics, mainObjectStatistics, options, objectType);
    case 'HOUSEHOLD':
      return CLIENTGROUP_STATS_FETCH(statistics, mainObjectStatistics, options, objectType);
    case 'ACCOUNT':
      return ACCOUNT_STATS_FETCH(statistics, mainObjectStatistics, options, objectType);
    case 'GOAL':
      return GOAL_STATS_FETCH(statistics, mainObjectStatistics, options, objectType);
    case 'SUB_ACCOUNT':
      return SUBACCOUNT_STATS_FETCH(statistics, objectType, options);
    default:
      return gql`
        query {
          __typename
        }
      `;
  }
};
